import React, { Component } from 'react';
import PropTypes from 'prop-types';

class RoundCheck extends Component {
  static = {
    icons: {
      female: (
        <path d="M1.7 21c-.5 0-1-.2-1.3-.7-.3-.4-.4-.9-.3-1.4l1.9-7.3c.5-1.9 2.2-3.2 4.2-3.2s3.7 1.3 4.2 3.2l1.9 7.3c.1.5 0 1-.3 1.4-.3.4-.8.7-1.3.7h-9zm1-17.6c0-1.9 1.5-3.4 3.4-3.4s3.5 1.5 3.5 3.4-1.5 3.4-3.4 3.4c-2 .1-3.5-1.5-3.5-3.4z" />
      ),
      male: (
        <path d="M2 17.8l-1.9-7.2c-.1-.5 0-1 .3-1.4.3-.4.8-.7 1.3-.7h8.9c.5 0 1 .2 1.3.7.3.4.4.9.3 1.5l-1.9 7.3c-.5 1.7-2.2 3-4.2 3-1.9 0-3.6-1.3-4.1-3.2zm.7-14.4c0-1.9 1.5-3.4 3.4-3.4s3.5 1.5 3.5 3.4-1.5 3.4-3.4 3.4c-2 .1-3.5-1.5-3.5-3.4z" />
      ),
    },
  };

  static propTypes = {
    checked: PropTypes.bool,
    icon: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
  };

  onChange = () => {
    const { onChange, name, value } = this.props;

    if (onChange) onChange(value, name);
  };

  render() {
    const { checked, icon, label, name, value, onChange } = this.props;
    const { icons } = this.static;

    return (
      <label className="round-check" title={label}>
        <input
          defaultChecked={checked}
          type="radio"
          name={name}
          value={value}
          onChange={this.onChange}
        />
        {label ? <span className="round-check__label">{label}</span> : null}
        <svg
          viewBox="0 0 12.3 21"
          width="21"
          height="21"
          className="round-check__sign"
          data-gender={icon}
        >
          {icons[icon]}
        </svg>
      </label>
    );
  }
}

export default RoundCheck;
